export default __webpack_public_path__ + "static/media/contactlessCommerce.png.webp";